import angular from 'angular';
import {Observable} from "rxjs/Observable";
import "rxjs/add/operator/do";
import "rxjs/add/operator/combineLatest";

import module from 'module';


class GroupLoansCreateService {
  constructor(http, groupCustomerCache, loanProductsCache, command, $location) {
    this.http = http;
    this.groupCustomerCache = groupCustomerCache;
    this.command = command;
    this.$location = $location;
  }

  getLoan(loanId) {
    return Observable.create(observer => {
      this.http.get(`/products/loans/${loanId}?includeAmortization=true`)
        .success(loan => {
          observer.next(loan);
          observer.complete();
        })
        .error(err => observer.error(err));
    })
  }

  getMemberLoans(customerId) {
    return this.getMembers(customerId)
      .combineLatest(this.groupCustomerCache.individualLoans(customerId).toObservable(), (members, loans) => {
        return members.map(member => ({
          ...member,
          loans: loans.filter(loan => loan.customerId === member.id)
        }))
      })
  }

  getMembers(customerId) {
    return this.groupCustomerCache.profile(customerId)
      .toObservable()
      .filter(p => p.customerType === 'GROUP' && p.customerGroup)
      .map(p => p.customerGroup.customers);
  }

  prepareLoanForSubmitting({customerGroupId, loan, }) {
    const clonedLoan = angular.copy(loan);
    clonedLoan.collateralFiles = undefined;
    clonedLoan.creationType = clonedLoan.creationType || 'NEW_LOAN';
    clonedLoan.automaticTransfer = false;

    return clonedLoan;
  }

  calculateLoan({customerGroupId, loan}) {
    const clonedLoan = this.prepareLoanForSubmitting({
      customerGroupId,
      loan,
    });

    return Observable.create(obs => {
      this.http.post('/products/loans/simulate', clonedLoan)
        .success(response => {
          obs.next(response);
          obs.complete();
        }, true)
        .error(resp => {
          obs.error(resp);
        })
    })
  }

  submitLoans(groupId, loans) {
    const loanRequests = loans.map(loan =>
      this.prepareLoanForSubmitting({
        customerGroupId: groupId,
        loan: loan.loan
      }));

    const request = {
      loanRequests,
      customerGroupId: groupId,
    };

    return this.command.execute('CreateLoanBatch', request);
  }
}

module.service('groupLoansCreateService', GroupLoansCreateService);
